import usersRoutes from './users/user-routes';
import notificationsRoutes from './notifications/notifications-routes';
import callsRoutes from './calls/calls-routes';
import appSettingsRoutes from './apps_settings/apps-settings-routes';

const adminRoutes = [
  ...callsRoutes,
  ...notificationsRoutes,
  ...usersRoutes,
  ...appSettingsRoutes,
];

export default adminRoutes;
